import React from 'react'
import { Helmet } from 'react-helmet'

const Dynatrace = () => {
  return (
    <Helmet>
      <script type="text/javascript" src="https://js-cdn.dynatrace.com/jstag/147f84b2bdc/bf26099sov/91baa6c76bb50844_complete.js" crossorigin="anonymous"></script>
    </Helmet>
  )
}

export default Dynatrace
